// encoding-helpers.ts
setTimeout(() => {
  if (!globalThis.navigator)
    globalThis.navigator = {};
}, 0);
var getOSForUserAgent = (userAgent = navigator.userAgent) => {
  if (userAgent.includes("Win"))
    return "Windows";
  if (userAgent.includes("Mac"))
    return "Macintosh";
  if (userAgent.includes("Linux"))
    return "Linux";
  if (userAgent.includes("Android"))
    return "Android";
  if (userAgent.includes("like Mac"))
    return "iOS";
  return "Unknown OS";
};
var getBestEncodingForUserAgent = (userAgent = navigator.userAgent) => {
  const os = getOSForUserAgent(userAgent);
  console.log("os", os);
  if (os === "Windows")
    return "windows1252";
  return "utf8";
};
export {
  getBestEncodingForUserAgent
};
